import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import axios from '../../../constents/axios';
import styles from './Assignment.module.css'; 
import { useNavigate } from 'react-router-dom';
const Assignment = () => {
  const [showInstructions, setShowInstructions] = useState(false);
  const [formData, setFormData] = useState({
    assignment_name: '',
    assignment_question: '',
    instruction_1: '',
    instruction_2: '',
    instruction_3: '',
    assignment_date: '',
    assignment_time: ''
  });
  const navigate = useNavigate();
      const storedData = localStorage.getItem("AssignmentData");
    let storedTopic; // Declare the variable outside the if block
    let storedCourse;
    let storedSubTopic;
  
      if (storedData) {
      const storedTopicData = JSON.parse(storedData); // Parse the string into an object
      storedTopic = storedTopicData.topicName; // Assign the value to the variable
      storedCourse = storedTopicData.courseName
      storedSubTopic = storedTopicData.subTopicName
    }
    
    console.log("storedTopic", storedTopic,storedCourse ,storedSubTopic); // Log the variable outside the if block
  

  const handleSwitchChange = () => {
    setShowInstructions(!showInstructions);
  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/create-assignment', {
        ...formData,
        topic: storedTopic,
        course_id: storedCourse,
        subTopic: storedSubTopic
      }, {
        headers: {
          "autherisation": `V9YlI4AgRJa97h9JT45acmijLliEcCEMnxZLtL7VlnWVETZuitk2MYoj0pCcrmHa`
        }
      });
      navigate(`/studentJourney/${storedCourse}`);
    } catch (err) {
      console.error(err);
      alert("Failed to add assignment.");
    }
  };

  return (
 <div className={`d-flex align-items-center ${styles.assignmentFormContainer}`}>
      <div className={`bg-light p-5 rounded w-100 ${styles.assignmentFormContent}`} >
        <h1>Create Assignment</h1>
        <Form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-6">
              <Form.Group className="mb-3">
                <Form.Label>Assignment Name</Form.Label>
                <Form.Control type="text" name="assignment_name" onChange={handleChange} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Assignment Question</Form.Label>
                <Form.Control as="textarea" name="assignment_question" rows={3} onChange={handleChange} required />
              </Form.Group>
              <Form.Check
                type="switch"
                className='mb-3'
                label="Add Instructions"
                onChange={handleSwitchChange}
                checked={showInstructions}
              />

              {showInstructions && (
                <>
                  <Form.Group className="mb-3">
                    <Form.Label>Instruction 1</Form.Label>
                    <Form.Control as="textarea" name="instruction_1" onChange={handleChange} />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Instruction 2</Form.Label>
                    <Form.Control as="textarea" name="instruction_2" onChange={handleChange} />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Instruction 3</Form.Label>
                    <Form.Control as="textarea" name="instruction_3" onChange={handleChange} />
                  </Form.Group>
                </>
              )}
            </div>

            <div className="col-6">
              <Form.Group className="mb-3">
                <Form.Label>Assignment Date</Form.Label>
                <Form.Control type="date" name="assignment_date" onChange={handleChange} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Assignment Time</Form.Label>
                <Form.Control type="time" name="assignment_time" onChange={handleChange} />
              </Form.Group>
            </div>
          </div>
          <button className="btn btn-primary" type="submit">Submit</button>
        </Form>
      </div>
    </div>
    
  );
};

export default Assignment;
